import request from "../utils/request";
//登录接口，post方式传参用data
export default {
  searchall: function (data) {
    return request({
      url: "/news/query",
      method: "post",
      data,
    });
  },
  login: function (data) {
    return request({
      url: "/user/login",
      method: "post",
      data,
    });
  },
  createnews: function (data) {
    return request({
      url: "/news/create",
      method: "post",
      data,
    });
  },
  editnews: function (data) {
    return request({
      url: "/news/update",
      method: "post",
      data,
    });
  },
  delnews: function (data) {
    return request({
      url: "/news/delete",
      method: "post",
      data,
    });
  },
  searchnews: function (data) {
    return request({
      url: "/news/get",
      method: "post",
      data,
    });
  },
  newslist: function (data) {
    return request({
      url: `/news/list`,
      data,
      method: "post",
    });
  },
  upload: function (data) {
    return request({
      headers: { "Content-Type": "multipart/form-data" },
      url: "/news/upload",
      method: "post",
      file: data,
    });
  },
  pcreate: function (data) {
    return request({
      url: "/product/create",
      method: "post",
      data: data,
    });
  },
  pdel: function (data) {
    return request({
      url: "/product/delete",
      method: "post",
      data: data,
    });
  },
  plist: function (data) {
    return request({
      url: "/product/list",
      method: "post",
      data: data,
    });
  },
  pupdate: function (data) {
    return request({
      url: "/product/update",
      method: "post",
      data: data,
    });
  },
};
